module.exports = __webpack_public_path__ + "img/SIKH TURBAN GREEN.3f9429b.svg";